import {ErrorStateScheduleEnum} from '../error-state-schedule.enum';

export enum ContactDetailsFormErrorStatesEnum {
    UserPhoneUpdateFailed = ErrorStateScheduleEnum.ContactDetailsFormStatesStartIndex
}
